import { createClient } from "@supabase/supabase-js";
import { hashHasFreshAuthFragment, writeLastActivity } from "@/lib/idle";

// Snapshot the boot hash NOW — createClient's detectSessionInUrl strips it
// asynchronously, often before React ever renders. A recovery/email-change
// fragment means the user just clicked an emailed link: that IS fresh activity,
// stamped here so neither the AuthContext boot guard nor IdleGuard's persisted
// stale timestamp can destroy the just-minted session (Step 7 carve-out, see idle.js).
export const bootHadFreshAuthLink =
  typeof window !== "undefined" && hashHasFreshAuthFragment(window.location.hash);
if (bootHadFreshAuthLink) writeLastActivity();

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

export const supabase = createClient(url, key, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Isolated, in-memory-only client for the accept-invite flow. Its session NEVER
// touches shared storage, so an admin signed in elsewhere in the same browser can
// neither answer for the invitee nor have their own session clobbered/killed.
export const inviteFlowClient = createClient(url, key, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false,
    storageKey: "hakina-invite-flow",
  },
});
